import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from "redux-thunk";

import { getDocumentListReducer, getVehicleListReducer, editDocumentReducer, checkVehicleReducer } from './redux/reducers/documentReducers'
import { userLoginReducer } from './redux/reducers/userReducers';
import { getJobCardTypeReducer, getVehicleNoReducer } from './redux/reducers/inputApiReducers'
import { selectVehicleIdReducer } from './redux/reducers/formReducers'
import { tyrePositionListReducer, createVehicleTypeReducer, getVehicleTypeReducer, updateVehicleTypeReducer } from './redux/reducers/vehicleTypeReducers'
import { updateApprovalStatusReducer } from './redux/reducers/jobCardReducers'
import { getCategoriesReducer, updateCategoryReducer, createCategoryReducer, deleteCategoryReducer} from './redux/reducers/categoryReducers'
import { makeReducer, modelReducer, insuranceCompanyReducer, getProductReducer, getVehicleReducer } from './redux/reducers/getApiReducers'

const reducer = combineReducers({
    getVehicleList: getVehicleListReducer,
    getDocumentList: getDocumentListReducer,
    userLogin: userLoginReducer,
    getJobCardType: getJobCardTypeReducer,
    getVehicleNo: getVehicleNoReducer,
    selectVehicleId: selectVehicleIdReducer,
    editDocumentList: editDocumentReducer,
    tyrePositionList: tyrePositionListReducer,
    createVehicleType: createVehicleTypeReducer,
    getVehicleType: getVehicleTypeReducer,
    updateVehicleType: updateVehicleTypeReducer,
    updateApprovalStatus: updateApprovalStatusReducer,
    getCategories: getCategoriesReducer,
    createCategory: createCategoryReducer,
    updateCategory: updateCategoryReducer,
    deleteCategory: deleteCategoryReducer,
    getMake: makeReducer,
    getModel: modelReducer,
    getInsuranceCompany: insuranceCompanyReducer,
    checkVehicle: checkVehicleReducer,
    getProduct: getProductReducer,
    getVehicle: getVehicleReducer

})

const middleware = [thunk];
const initialState = {};


const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    reducer,
    initialState,
    composeEnhancer(applyMiddleware(...middleware))
)

export default store;